import { PlusOutlined } from "@ant-design/icons";
import { useMount } from "ahooks";
import { isNil } from "ramda";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { CreateTutorial } from "@/components/create-tutorial/create-tutorial";
import { localGet, localRemove } from "@/utils/storage";

import styles from "./quick-generate-tutorial.module.less";

export const QuickGenerateTutorial: FC = () => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    localRemove("isIntelligentCreation");
    localRemove("tutorialEditId");
    sessionStorage.removeItem("audioInfo");
  };

  useMount(() => {
    const isHasIntelligentCreation = localGet("isIntelligentCreation");

    const tutorialEditId = localGet("tutorialEditId");

    if (isNil(isHasIntelligentCreation) || !isNil(tutorialEditId)) {
      return;
    }
    setIsModalOpen(true);
  });

  return (
    <>
      <div
        className={styles["generate-tutorial-btn"]}
        onClick={handleOpenModal}
      >
        <PlusOutlined
          style={{ color: "#fff", fontSize: "12px", verticalAlign: "middle" }}
        />
        <span className={styles["txt"]}>
          {t("intelligent_creation.intelligent_creation")}
        </span>
      </div>
      <CreateTutorial open={isModalOpen} onClose={handleClose} />
    </>
  );
};
